import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type {
  IReduxRequestNode,
  IStandardGUJRequestParams,
} from "@litres-libs/types";
import { Request } from "../../request/Request";
import { addHydrateReducer } from "../../utils/hydrateReducer";

export interface IAvaliableBonus {
  isOnetype: boolean;
  isUsed: boolean;
  title: string;
  eventType: number;
  moneyBonus?: number;
}

interface IAvailableLoyaltiesState {
  list:
    | {
        [avaliableLoyaltyName: string]: IAvaliableBonus;
      }
    | undefined;
  actions: {
    getAvailableBonusesListGUJ: IGetSocialNetworkGUJNode;
  };
}
type IGetSocialNetworkGUJNode = IReduxRequestNode<
  IGetSocialNetworkGUJRequest,
  IGetSocialNetworkGUJResponse
>;

const initialState: IAvailableLoyaltiesState = {
  list: {}, // В этой строке хранится ILegacyPhoneCodes["countriez"] массив
  actions: {
    getAvailableBonusesListGUJ: {},
  },
};

type IGetSocialNetworkGUJRequest = IStandardGUJRequestParams;
interface IGetSocialNetworkGUJResponse {
  [avaliableLoyaltyName: string]: IAvaliableBonus;
}

export const getAvailableBonusesListGUJ = createAsyncThunk(
  "pages/personalCabinet/getAvailableBonusesListGUJ",
  async (params: {
    onSuccess?: (success: IGetSocialNetworkGUJNode) => void;
    onError?: (error: IGetSocialNetworkGUJNode) => void;
  }) => {
    const response = new Request.CSRF<
      IGetSocialNetworkGUJRequest,
      IGetSocialNetworkGUJResponse
    >({
      url: "/pages/personal_cabinet_login/?lite=1&social_logins=1&gu_ajax=1",
      provider: {
        id: "get_available_bonuses_list",
      },
      request: {
        method: "GET",
      },
      onSuccess: params.onSuccess,
      onError: params.onError,
    });

    return await response.fetch();
  }
);

export const availableBonusesSlice = createSlice({
  name: "global/avaliableBonuses",
  initialState,
  reducers: {
    // Нет сеттеров
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "global.availableBonuses");
    /**
     * Запрос поиска по текстовому ключу
     */
    builder.addCase(
      getAvailableBonusesListGUJ.pending,
      (state: IAvailableLoyaltiesState) => {
        state.actions.getAvailableBonusesListGUJ.isLoading = true;
        state.actions.getAvailableBonusesListGUJ.error = undefined;
      }
    );
    builder.addCase(
      getAvailableBonusesListGUJ.fulfilled,
      (
        state: IAvailableLoyaltiesState,
        action: PayloadAction<IGetSocialNetworkGUJNode>
      ) => {
        state.actions.getAvailableBonusesListGUJ.isLoading = false;

        if (action.payload.response) {
          state.list = action.payload.response;
        }

        // TODO: Ошибку точно не надо как-то визуально обработать в интерфейсе?
        if (action.payload.error) {
          console.error("Ошибка запроса phonecodesSlice", action.payload.error);
          state.actions.getAvailableBonusesListGUJ.error = action.payload.error;
        }
      }
    );
  },
});

export default availableBonusesSlice.reducer;
